import { render, staticRenderFns } from "./total-invest.vue?vue&type=template&id=7cf1bfb9&scoped=true"
import script from "./total-invest.vue?vue&type=script&lang=js"
export * from "./total-invest.vue?vue&type=script&lang=js"
import style0 from "./total-invest.vue?vue&type=style&index=0&id=7cf1bfb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf1bfb9",
  null
  
)

export default component.exports